module.exports = __webpack_public_path__ + "static/img/1-1.706637e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/1-1.png
// module id = OJNj
// module chunks = 0